import { SiteAssetMapPage } from '~/app/components/site-asset-map/SiteAssetMapPage';

export const SiteAssetMapPageContainer = () => <SiteAssetMapPage />;
